import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { Galops } from "./pages/galops";
import { activeTabSubject, results, statisticsOptions } from "./stores/statistics.store";
import FilterTab from "./components/shared/filter_tab/filter_tab";
import { BestDegree } from "./pages/best_degree";
import { useEffect } from "react";
import { useForceUpdate } from "./services/misc.functions";
import { PreviousRuns } from "./pages/previous_runs";
import { PreviousWins } from "./pages/previous_wins";
import { WhoRunWithWhom } from "./pages/who-ran-with-whom";

export default function AppRouters() {
  const forceUpdate = useForceUpdate();
  useEffect(() => {
    const subscription = activeTabSubject.subscribe(() => {
      forceUpdate();
    });

    return () => {
      subscription.unsubscribe();
    };
  }, [forceUpdate]);

  return (
    <Router>
      <FilterTab results={results} selectedHippodrome={statisticsOptions.selectedHippodrome} />
      <Routes>
        <Route path="/galoplar-sprintler" element={<Galops />} />
        <Route path="/en-iyi-dereceler" element={<BestDegree />} />
        <Route path="/son-kosular" element={<PreviousRuns />} />
        <Route path="/birincilikler" element={<PreviousWins />} />
        <Route path="/kim-kiminle-kostu" element={<WhoRunWithWhom />} />
      </Routes>
    </Router>
  );
}
